import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { withExperiments, InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { ConnectedProps, connect } from 'react-redux';
import { State } from '../../redux/configure-store';
import { ModalName } from '../../types/ModalNames';
import { showModal } from '../../redux/actions/activeModal.actions';
import { getPendingOwnerEmail } from '../../redux/selectors/teamDetails';

import { TextButton } from 'wix-style-react';

interface IProps extends InjectedTranslateProps, InjectedExperimentsProps, ConnectedProps<typeof connector> {
}

class TeamMembersOwnerActionCell extends React.Component<IProps> {

  render() {
    const { transferringOwnershipEmail, t, onTransferOwnership } = this.props;
    if (transferringOwnershipEmail) {
      return null;  //<Text size="small">{t('list.owner.transferringTo', { email: transferringOwnershipEmail })}</Text>
    }
    return <div style={{ paddingRight: '18px' }}>
      <TextButton size="small" onClick={onTransferOwnership}>{t('list.owner.transferOwnership')}</TextButton>
    </div>;
  }
}

const mapStateToProps = (state: State) => {
  return {
    transferringOwnershipEmail: getPendingOwnerEmail(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onTransferOwnership: () => {
    dispatch(showModal(ModalName.TransferOwnership, { }));
  }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(withExperiments(translate()(TeamMembersOwnerActionCell)));
